<template>
  <div>
    <span>This is OSM</span>
    <div style="background: white; padding: 10px; border:1px solid rgba(0,0,0,0.2);padding-bottom: 200px;">
      Will's Sample Here
      <b-col sm="12">
        <b-form-group>
          <FITCheckbox v-model="contents.FITCheckbox.value" v-bind="contents.FITCheckbox"></FITCheckbox>
          <span>{{contents.FITCheckbox.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITTextInput v-model="contents.FITTextInput.value" v-bind="contents.FITTextInput"></FITTextInput>
          <span>{{contents.FITTextInput.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITCheckboxGroup v-model="contents.FITCheckboxGroup.value" v-bind="contents.FITCheckboxGroup"></FITCheckboxGroup>
          <span>{{contents.FITCheckboxGroup.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITRadio v-model="contents.FITRadio.value" v-bind="contents.FITRadio"></FITRadio>
          <span>{{contents.FITRadio.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITTextarea v-model="contents.FITTextarea.value" v-bind="contents.FITTextarea"></FITTextarea>
          <span>{{contents.FITTextarea.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITSelect v-model="contents.FITSelect.value" v-bind="contents.FITSelect"></FITSelect>
          <span>{{contents.FITSelect.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITDatePicker v-model="contents.FITDatePicker.value" v-bind="contents.FITDatePicker"></FITDatePicker>
          <span>{{contents.FITDatePicker.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITTimepicker v-model="contents.FITTimepicker.value" v-bind="contents.FITTimepicker"></FITTimepicker>
          <span>{{contents.FITTimepicker.value}}</span>
        </b-form-group>
      </b-col>
      <div class="row mr-auto ml-auto">
        <div v-for="variant in ['primary','secondary','success','outline-success','warning','danger','link']">
          <div class="col-md-4 pb-2" v-for="size in ['sm','','lg']" :key="`${variant}_${size}`">
            <FITButton :size="size" :variant="variant" :text="`${variant} ${size}`" @click="finalCheck()"></FITButton>
          </div>
        </div>
      </div>
      <b-col sm="12">
        <b-form-group>
          <FITDropdown v-model="contents.FITDropdown.value" v-bind="contents.FITDropdown"></FITDropdown>
          {{contents.FITDropdown.value}}
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITvSelect v-model="contents.FITvSelect.value" v-bind="contents.FITvSelect"></FITvSelect>
          <span>{{contents.FITvSelect.value}}</span>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITAutoSearch v-model="contents.FITAutoSearch.value" v-bind="contents.FITAutoSearch"></FITAutoSearch>
          {{contents.FITAutoSearch.value}}
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITFileUpload linkedEntity="L" linkedEntityID="10"></FITFileUpload>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <FITWorkflowFileUpload linkedEntity="L" linkedEntityID="10" :uploadedFiles="contents.FITWorkflowFileUpload.uploadedFiles"></FITWorkflowFileUpload>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <h5 class="py-2">FIT Outstanding requirement (Agent Version)</h5>
          <FITOutstandingRequirement accountType="agent" policyType="G" policyID="84"></FITOutstandingRequirement>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group>
          <h5 class="py-2">FIT Outstanding requirement (Admin Version)</h5>
          <FITOutstandingRequirement accountType="admin" policyType="G" policyID="84"></FITOutstandingRequirement>
        </b-form-group>
      </b-col>
    </div>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import { FITCheckbox, FITTextInput, FITCheckboxGroup, FITRadio, FITTextarea, FITSelect, FITDatePicker, FITTimepicker, FITvSelect } from '@/components'
import { FITButton, FITDropdown, FITAutoSearch, FITFileUpload, FITOutstandingRequirement } from '@/components'
import FITWorkflowFileUpload from '@/components/Form/FITWorkflowFileUpload'

export default {
  name: 'Osm',
  components: {
    FITCheckbox,
    FITTextInput,
    FITCheckboxGroup,
    FITRadio,
    FITTextarea,
    FITSelect,
    FITDatePicker,
    FITTimepicker,
    FITButton,
    FITDropdown,
    FITvSelect,
    FITAutoSearch,
    FITFileUpload,
    FITOutstandingRequirement,
    FITWorkflowFileUpload
  },
  methods:{
    finalCheck(){
      // Pause Here
      this.$store.commit('Validation/setValidationFinalCheck',{finalCheck:true});
      console.log(this.$store.state.LifePolicy.validations.generalInfo);
      return 1;
    }
  },
  data() {
    return {
      selected: '',
      contents: {
        // Text Input
        FITTextInput: {
          value: 'asdfa',
          label: 'Name',
          placeholder: "Please Enter Your Name",
          width: 10,
          disabled: false,
          rule: {
            required: true,
            policy: true,
          },
          field: "Name",
          vuexObject: "WillTemplate",
        },
        // Checkbox
        FITCheckbox: { value: true, label: "FITCheckbox", trueString: "true", falseString: "false", disabled: false },
        // Textarea
        FITTextarea: {
          value: "",
          label: "FITTextarea",
          placeholder: 'Left your message here',
          width: 10,
          rows: 3,
          maxRows: 6,
          disabled: false,
          rule: { required: true },
          field: "FITTextarea",
          // vuexObject:"WillTemplate",
        },
        // Checkbox Group
        FITCheckboxGroup: {
          value: ['orange', 'grape'],
          label: "FITCheckboxGroup",
          stacked: false,
          width: 10,
          disabled: false,
          options: [
            { text: 'Orange', value: 'orange' },
            { text: 'Apple', value: 'apple' },
            { text: 'Pineapple', value: 'pineapple', disabled: true },
            { text: 'Grape', value: 'grape' }
          ]
        },
        // Radio
        FITRadio: {
          value: 'apple',
          label: "FITRadio",
          stacked: true,
          width: 10,
          disabled: false,
          options: [
            { text: 'Orange', value: 'orange' },
            { text: 'Apple', value: 'apple' },
            { text: 'Pineapple', value: 'pineapple', disabled: true },
            { text: 'Grape', value: 'grape' }
          ]
        },
        // Select
        FITSelect: {
          value: 'orange',
          label: "FITSelect",
          width: 10,
          disabled: false,
          selectSize: 1,
          options: [
            { text: 'No Options', value: null },
            { text: 'Orange', value: 'orange' },
            { text: 'Apple', value: 'apple' },
            { text: 'Pineapple', value: 'pineapple', disabled: true },
            { text: 'Grape', value: 'grape' }
          ],
          rule: { required: true },
          field: "FITSelect",
          vuexObject: "WillTemplate",
        },
        // Datepicker    Note : lang active without placeholder
        FITDatePicker: {
          value: '',
          format: 'YYYY-MM-DD',
          label: 'FITDatePicker',
          lang: 'en',
          placeholder: '',
          width: 10,
          disabled: false,
          rule: { required: true },
          field: "Datepicker",
          // vuexObject:"WillTemplate",
        },
        // Timepicker    Note : lang active without placeholder
        FITTimepicker: { value: '', format: 'HH:mm:ss', initValue: { 'HH': '05', 'mm': '11', 'ss': '33' }, minuteInterval: 6, secondInterval: 10, label: 'FITTimepicker', width: 10 },
        // FITDropdown   
        FITDropdown: {
          value: '',
          text: 'Hello',
          variant: 'primary',
          disabled: false,
          size: '',
          listAlign: 'left',
          direction: 'dropup',
          options: [
            { text: "option1", link: "", disabled: true },
            { text: "option2", link: "" },
            { text: "option3", link: "link3" }
          ]
        },
        // FITvSelect  Note: placeholder active without value,
        FITvSelect: {
          // value: { label: 'Orange', value: 'orange' },
          value: '',
          label: "FITvSelect",
          placeholder: 'Type Sth Here',
          width: 10,
          disabled: false,
          useApi: true,
          dest: 'option',
          paras: [{ key: 'type', value: 'agent' }],
          options: [
            { label: 'Orange', value: 'orange' },
            { label: 'Apple', value: 'apple' },
            { label: 'Pineapple', value: 'pineapple' },
            { label: 'Grape', value: 'grape' }
          ]
        },
        FITAutoSearch: {
          value:{ID:"0"},
          label: 'FITAutoSearch',
          placeholder: 'Type to search',
          width: 10,
          dest: 'option',
          //paras: [{ key: 'type', value: 'agent' }],
          paras: [
            { key: 'type', value: 'agent' },
            { key: 'ID', value: '2' },
          ],
          showItems: ['chineseFullname', 'englishFullname'],
          rule: { required: true },
          field: "AutoSearchName",
        },
        FITWorkflowFileUpload: {
          uploadedFiles: [{
                'fileName': 'nightblade-irelia-lol-splash-art-update-league-of-legends-z205.jpg',
                'size': '120000',
                'publicDocument': 'Y',
                'documentTag': 'asdf,adsf,',
                'remarks': 'remarks'
              },
              {
              'fileName': 'nightblade-irelia-lol-splash-art-update-league-of-legends-z205.jpg',
              'size': '120000',
              'publicDocument': 'Y',
              'documentTag': 'asdf,adsf,',
              'remarks': 'remarks'
            }
          ],
        }
      },

    }
  },

}

</script>



// WEBPACK FOOTER //
// src/ErrorPage/containers/WillTemplate.vue